export default "__VITE_ASSET__eaadd4f2__"